import { c as _defineProperty } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { s as styles } from '../_grid-057c99b7.js';

var Grid = function Grid(_ref) {
  var _bemGrid$b;

  var children = _ref.children,
      applyContainer = _ref.applyContainer,
      align = _ref.align,
      justify = _ref.justify;
  var bemGrid = Bem('grid', styles);
  var bemGridContainer = Bem('grid-container', styles);
  var bemGridClassNames = bemGrid.b((_bemGrid$b = {}, _defineProperty(_bemGrid$b, "align-".concat(align), align), _defineProperty(_bemGrid$b, "justify-".concat(justify), justify), _bemGrid$b));
  var gridRow = React.createElement("div", {
    className: bemGridClassNames
  }, children);
  return React.createElement(React.Fragment, null, applyContainer ? React.createElement("div", {
    className: bemGridContainer.b()
  }, gridRow) : gridRow);
};
Grid.defaultProps = {
  applyContainer: false,
  align: null,
  justify: null
};

function gridColTypeRequired(props, propName, componentName) {
  var error;
  var prop = props[propName];

  if (prop == null) {
    // Prop wasn't specified. Throw an error.
    error = new Error("`".concat(propName, "` is required for `").concat(componentName, "`."));
  } else {
    React.Children.forEach(prop, function (child) {
      if (child && child.type.displayName !== 'GridCol' && child.type !== React.Fragment) {
        // display in error which component is actually given
        var childName = child.type.displayName ? child.type.displayName : child.type.name;
        error = new Error("`".concat(componentName, "` only accepts children of type `GridCol` or `React.Fragment`, but `").concat(childName, "` is given."));
      }
    });
  }

  return error;
}

Grid.displayName = 'Grid';
Grid.propTypes = {
  /** Grid should contain only GridCol components or React.Fragment as direct children */
  children: gridColTypeRequired,
  // eslint-disable-line

  /** Wraps grid in a container if needed,
   * useful for root elements or other cases when negative margins might cause issues  */
  applyContainer: PropTypes.bool,

  /** Controls vertical alignment of columns, matches flexbox's align-items rule */
  align: PropTypes.oneOf(['top', 'bottom', 'center']),

  /** Controls horizontal alignment of columns (distribution),
   *  matches flexbox's justify-content rule */
  justify: PropTypes.oneOf(['left', 'right', 'center'])
};
var grid = Injecss(Grid, styles);

export { grid as Grid };
